import {UnavailableState} from './states/UnavailableState';
import './unavailable.css';

let appMoudule = angular.module('deliveryCreate.app');
appMoudule.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
    $stateProvider.state(UnavailableState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unavailable/bootstrap.ts
 **/